import SwitchBtn from 'bootstrap-switch-button'

export default function() {

  document.querySelectorAll('input.switch[type=checkbox]').forEach(function(ele) {
		new SwitchBtn(ele, {
        width:    ele.dataset.width    || '120',
				onstyle:  ele.dataset.onStyle  || 'success',
				offstyle: ele.dataset.offStyle || 'danger',
        onlabel:  ele.dataset.onLabel  || 'PAGO',
        offlabel: ele.dataset.offLabel || 'NÃO PAGO',
      })
	});

}
